'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:getExpress');
}

var _invoke = require('../invoke');

/**
 * 获取邮寄地址
 *
 * @memberof flight
 * @static
 * @name getExpress
 * @param {siteId} siteId,
 * @param {int} id 默认为 '',
 * @return {Promise}
 * @example
 hbnb.flight.getExpress(1, '').then(function(data) {
     data = {
         id: 'id is number',
         name: 'name is string',
         mobile: 'mobile is string',
         province: 'province is string',
         city: 'city is string',
         district: 'district is string',
         address: 'address is string',
         postCode: 'postCode is string',
         expressAmount: 'expressAmount is string'
     }
 });
 */
module.exports = function(siteId, id) {
    var p = new Promise(function(resolve, reject) {
        _invoke('flight', 'get_express', {
            siteId: siteId,
            id: id,
            callback: function(date) {
                resolve(date);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/flight/get-express.js
// module id = 577
// module chunks = 0